<template>
	<div>
		<page-filter ref="filter" @updateTab="filter" />
		<aBox title="GRID DE PROPOSTAS">
			<div slot="tools">
				<aBtn
					action="private-save-sstPropostals"
					text="Proposta"
					icon="plus"
					size="sm"
					type="success"
					@click="$refs.pModal.open()"
				/>
			</div>
			<div slot="body">
				<aTable
					ref="tProps"
					actionRead="private-read-sstProposals"
					actionDelete="private-delete-sstProposals"
					:labels="labels"
					:functions="functions"
					:actions="['delete']"
					@updated="loadButtons"
					:lineStatus="fxStatus"
					:block="true"
				/>
			</div>
		</aBox>

		<p-modal ref="pModal" @update="$refs.tProps.updateTable()" />
		<md-cliente ref="MdCliente" @update="fxUpAsMd" />
	</div>
</template>
<script>
	import aBox from 'box';
	import aTable from 'table';
	import pad from 'js/pad';
	import aBtn from 'btn';
	import eDate from 'js/date';
	import pModal from './components/modal.vue';

	import MdCliente from '../cadastros/customers/modal.vue';
	import PageFilter from './components/filter.vue';

	export default {
		name: 'appProposalsBase',
		components: { aBox, aTable, pModal, aBtn, MdCliente, PageFilter },
		provide() {
			return {
				openMdCliente: (e) => this.$refs.MdCliente.open(),
			};
		},
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{
						data: ['razao_social', 'cnpj'],
						label: 'Empresa',
						two: true,
					},
					{ data: 'data', label: 'Data' },
					{ data: 'regiao', label: 'Região' },
					{ data: 'dVendedor.vendedor', label: 'Vendedor' },
					{ data: 'list_services', label: 'Valor', class: 'warning' },
				],
				functions: [
					{
						cod: 'cod',
						fx: (e) => {
							return `<button class='btn-edit btn btn-primary btn-xs' disabled data-id='${e}'>
							<i class='fa fa-edit'></i> ${pad(e, 5, 0)}
						</button>`;
						},
					},
					{
						cod: 'data',
						fx: (e) => {
							return eDate(e, 'DD/MM/YY');
						},
					},
					{
						cod: 'dVendedor.vendedor',
						fx: (e) => {
							// console.log(e);
							return `<span class='label label-default'>
							<i class='fa fa-user'></i> ${e}
						</span>`;
						},
					},
					{ cod: 'list_services', fx: this.calcAmount },
					{
						cod: 'regiao',
						fx: (e) => {
							return `<span class='label label-success'>
							<i class='fa fa-map-marker'></i> ${e}
						</span>`;
						},
					},
				],
			};
		},
		methods: {
			calcAmount(list) {
				const bruteValue = list.reduce((acc, item) => {
					if (item.check)
						acc +=
							+item.qnt * +item.valor +
							+item.acrescimo -
							+item.desconto;
					return acc;
				}, 0);
				return `R$ ${parseFloat(+bruteValue).toFixed(2)}`;
			},
			filter(val) {
				// console.log(val)
				this.$refs.tProps.setFilter(val);
				this.$refs.tProps.updateTable();
			},
			fxUpAsMd(data) {
				this.$refs.pModal.updateAssetsClientes(data);
			},
			loadButtons() {
				$('.btn-edit').removeAttr('disabled');
				let self = this;
				$('.btn-edit').on('click', async function () {
					let data = await self.$refs.tProps.getRow(
						$(this).data('id')
					);
					self.$refs.pModal.open(data);
				});
			},
			fxStatus(val) {
				if (val.status == 'CC') return 'danger';
				// console.log(val);
			},
		},
		mounted() {
			this.$refs.filter.update();
			this.$emit('setHeader', ['Propostas', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/proposals/index.vue